export default __webpack_public_path__ + "static/media/7.82f8e109.jpg";